import React from "react";
import { Card, Elevation, Button, Icon } from "@blueprintjs/core";
import CreateNewCircleDecorator from '../../containers/CreateNewCircleDecorator';
import LoadingIndicator from "../LoadingIndicator";
import { Translate } from "react-redux-i18n";

export default function LoadMoreCard({
  onLoadMoreClick,
  isLoading
}) {
  return (
    <Card
      interactive={false}
      elevation={Elevation.ONE}
      className="product-card load-more">
      {!isLoading && (
        <div className="load-cta" onClick={onLoadMoreClick}>
          <Icon icon="more" iconSize="32" className="icon" />
          <strong>
            <Translate value="general_messages.load_more" />
          </strong>
        </div>
      )}
      {isLoading && <LoadingIndicator />}
      <div className="separator">
        <span>
          <Translate value="or" />          
        </span>
      </div>
      <CreateNewCircleDecorator empty_circle >
        <Button intent="primary" className="cta" >
          <Translate value="new_circle.create" />
        </Button>
      </CreateNewCircleDecorator>
    </Card>
  );
}
